var _path, _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 10.4H9.22701H3.00001C2.28501 10.4 1.70001 10.985 1.70001 11.7C1.70001 11.817 1.71301 11.934 1.75201 12.051L5.05401 24.102C5.35301 25.194 6.35401 26 7.55001 26H24.45C25.646 26 26.647 25.194 26.959 24.102L30.261 12.051L30.3 11.7C30.3 10.985 29.715 10.4 29 10.4H22.5ZM15.9584 13C15.4061 13 14.9584 13.4477 14.9584 14V22.4C14.9584 22.9523 15.4061 23.4 15.9584 23.4H16.0416C16.5939 23.4 17.0416 22.9523 17.0416 22.4V14C17.0416 13.4477 16.5939 13 16.0416 13H15.9584ZM8.38512 14.4342C8.28288 13.8915 8.64174 13.3786 9.18666 13.2886L9.26489 13.2757C9.8098 13.1858 10.3344 13.5529 10.4367 14.0956L11.9957 22.3722C12.098 22.9149 11.7391 23.4278 11.1942 23.5177L11.1159 23.5306C10.571 23.6206 10.0464 23.2535 9.94418 22.7108L8.38512 14.4342ZM22.7351 13.1629C22.1902 13.0729 21.6656 13.44 21.5633 13.9827L20.0043 22.2593C19.9021 22.802 20.2609 23.3149 20.8058 23.4049L20.8841 23.4178C21.429 23.5077 21.9536 23.1406 22.0558 22.5979L23.6149 14.3213C23.7171 13.7786 23.3583 13.2657 22.8133 13.1758L22.7351 13.1629Z",
    fill: "#FF6900"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.66823,
    height: 12.1784,
    rx: 1,
    transform: "matrix(0.876259 -0.481841 0.518381 0.85515 17.7489 1.28568)",
    fill: "#FF6900"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.66822,
    height: 12.1784,
    rx: 1,
    transform: "matrix(-0.876259 -0.481841 -0.518381 0.85515 14.2511 1.28568)",
    fill: "#FF6900"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.400009,
    y: 9.10001,
    width: 31.2,
    height: 3.9,
    rx: 1,
    fill: "#FF6900"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.0666506a.svg";
export { ForwardRef as ReactComponent };